import { Heading } from "@sentricmusic/ui";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import validator from "email-validator";
import qs from "qs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";

import { useSignup } from "@/api/mutations";
import useSiteConfigUnAuth from "@/api/sanity/queries/getSiteConfigWithDomain";
import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import ButtonLink from "@/components/ButtonLink";
import FormError from "@/components/FormError";
import Input from "@/components/Input";
import Spacer from "@/components/Spacer";
import { useUIStateStore } from "@/store/uiStateStore";

// const qs = require('qs');

// const validator = require('email-validator');

function SignUp() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mutationErrorMessage, setMutationErrorMessage] = useState("");
  const [validationErrorMessage, setValidationErrorMessage] = useState("");
  const [valid, setValid] = useState(false);
  const [pending, setPending] = useState(false);

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const locationSearch = useRouterState({ select: s => s.location.searchStr });
  const { data: domainConfig } = useSiteConfigUnAuth();
  const signUpMutation = useSignup();
  const cookies = new Cookies();

  const isTunecore = useUIStateStore(state => state.isTunecore);

  console.log(isTunecore);

  let searchObj = null;

  if (locationSearch) {
    searchObj = qs.parse(locationSearch, { ignoreQueryPrefix: true });
    cookies.set("s-ref", searchObj?.ref, { path: "/" });
  }

  const signUp = async () => {
    setValid(false);
    setMutationErrorMessage("");
    setValidationErrorMessage("");
    setPending(true);
    const data = {
      firstname: firstName,
      lastname: lastName,
      email,
      returnurl: `${window.location.protocol}//${window.location.host}/confirm`,
    };

    signUpMutation.reset();

    signUpMutation.mutate(data, {
      onSuccess: (response) => {
        if (response.failedvalidation) {
          setValidationErrorMessage(response.data.messages);
          setPending(false);
        }
        else {
          navigate({ to: "/sign-up-continue" });
          setPending(false);
        }
      },
      onError: (error) => {
        setMutationErrorMessage(error.message);
        setValid(true);
        setPending(false);
      },
    });
  };

  const checkValid = (passed = {}) => {
    let val = true;

    // email check
    const validEmail = validator.validate(passed.email || email);
    if (!validEmail) {
      val = false;
    }

    // firstname check
    const name = passed.firstName || firstName;
    const validFirstName = name.trim().length > 0;
    if (!validFirstName) {
      val = false;
    }

    // lastname check
    const lname = passed.lastName || lastName;
    const validLastName = lname.trim().length > 0;
    if (!validLastName) {
      val = false;
    }

    setValid(val);
  };

  const checkErrors = () => {
    const errs = {};

    // email check
    if (email.trim().length > 0) {
      const validEmail = validator.validate(email);
      if (!validEmail) {
        errs.email = t("regex:invalid-email-error");
      }
    }

    // first name check
    if (firstName.trim().length > 0) {
      const validFirstName = firstName.trim().length > 0;
      if (!validFirstName) {
        errs.firstName = t("regex:enter-first-name-check");
      }
    }

    // last name check
    if (lastName.trim().length > 0) {
      const validLastName = lastName.trim().length > 0;
      if (!validLastName) {
        errs.lastName = t("regex:enter-last-name-check");
      }
    }

    setErrors(errs);
  };

  return (
    <div>
      <Heading as="h1" className="text-white">
        {t("auth:join-header")}
        {" "}
        {domainConfig?.display_name}
      </Heading>
      <div className="w-full text-ink-primary">
        <Spacer />
        <Input
          id="txtSignupEmail"
          className="auth-page-input"
          whiteLabelText
          error={errors.email}
          placeholder={t("auth:email-placeholder2")}
          value={email}
          onBlur={() => checkErrors()}
          onChange={(e) => {
            setEmail(e.target.value);
            checkValid({ email: e.target.value });
          }}
        />
        <Spacer />
        <Input
          id="txtSignupFirstName"
          whiteLabelText
          className="auth-page-input"
          error={errors.firstName}
          type="text"
          placeholder={t("auth:first-name")}
          onBlur={() => checkErrors()}
          value={firstName}
          onChange={(e) => {
            setFirstName(e.target.value);
            checkValid({ firstName: e.target.value });
          }}
        />
        <Spacer />
        <Input
          className="auth-page-input"
          whiteLabelText
          id="txtSignupLastName"
          error={errors.lastName}
          type="text"
          placeholder={t("auth:last-name")}
          value={lastName}
          onBlur={() => checkErrors()}
          onChange={(e) => {
            setLastName(e.target.value);
            checkValid({ lastName: e.target.value });
          }}
        />
        <Spacer />
        <FormError
          mutationError={mutationErrorMessage}
          validationError={validationErrorMessage}
        />
        <div className="flex justify-center w-full">
          <AuthPrimaryButton
            id="btnSignupNext"
            disabled={!valid}
            pending={pending}
            onClick={signUp}
          >
            {t("common:next-button")}
          </AuthPrimaryButton>
        </div>
      </div>
      <Spacer />
      <div className="flex justify-between">
        <ButtonLink
          id="btnSignupLogin"
          className="mr-8"
          onClick={() => navigate({ to: "/login" })}
        >
          {t("common:login-link")}
        </ButtonLink>
        <ButtonLink
          id="btnSignupForgotPassword"
          onClick={() => navigate({ to: "/reset-password" })}
        >
          {t("auth:forgot-password")}
        </ButtonLink>
      </div>
    </div>
  );
}

export default SignUp;
